import React, { useRef, useState, useEffect } from "react";
import { Button, message, Form, Space, Select, Input, Row, Col, Table, UploadFile, Modal, Image } from "antd";
import { YhBox } from "@/components/YhBox";
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption, IYhFormRef } from "@/components/YhFormBoxVertical/Types";
import { useGoodsModel } from "../materialModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IFormGoodsFields } from "../materialService";
import { getFormValidatorErrText } from "@/utils/utils"
import { DetailType } from "@/types/ScmEnums";
import { ITreeSelectData, useDictModel } from "../../dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";
import { warehouseService } from "../../warehouse/warehouseService";
import { IVRMshelfDetail } from "../../warehouse/warehouseTypes";
import { debounce } from "lodash";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { FontSizeOutlined, MinusCircleOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { IMaterialDetail, IWarehouseMaterialDetal } from "../materialService"
import { globalPrompt } from '@/components/message';
import { YHDetailNav } from "@/components/YHDetailNav";
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from "@/utils/constants";
import Upload, { UploadChangeParam } from "antd/lib/upload";
export const MaterialDetails = () => {
    // const { shopAndOrg: { shopCode,shopId, shopName } } = useGlobalModel();
    const {
        addFormVal,
        editFormVal,
        lookFormVal,
        initForm,
        shelfAllList,
        setShelfAllList,
        updateAddFormVal,
        updateEditFormVal,
        insertGoods,
        editGoods,
        getGoodsOne,
        setAddFormVal,
        setSelectedRowKeys,
        warehouseDetalList,
        initWarehouseDetalList,
        editWarehouseDetalList,
        lookWarehouseDetalList,
        setWarehouseDetalList,
        saveLoading, setSaveLoading, dataList
    } = useGoodsModel();
    const { warehouseList, shopAndOrg: { shopCode, shopId, shopName } } = useGlobalModel()
    const [form] = Form.useForm();

    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const formRef = useRef<IYhFormRef>();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { id, mode, } = detailsInfo
    const { getSelectedDictOne, getTreeSelectOne } = useDictModel();
    //编辑时， 没有缓在调用详情接口

    useEffect(() => {
        if (!Object.keys(editFormVal).length && detailsInfo.mode === DetailType.edit) {
            getGoodsOne(id, mode)
        }
        mode === DetailType.look && getGoodsOne(id, mode)

    }, [detailsInfo]);

    //关闭当前页
    const onClose = () => {
        replaceNav(selectedNavId, "13-2");
        formRef.current?.resetFields();
        form.resetFields();
    }
    useEffect(() => {
        return () => {
            let addNavExist = findNav("13-2-1");
            let editNavExist = findNav("13-2-2");
            !addNavExist && updateAddFormVal(null);
            !editNavExist && updateEditFormVal(null);
        }
    }, [id, mode, selectedNavId])
    const typeForm = {
        add: addFormVal,
        edit: editFormVal,
        look: lookFormVal
    }
    // 找到normFile函数，替换为以下代码
    const normFile = (e: UploadChangeParam) => {
        if (Array.isArray(e)) {
            return e;
        }
        const { file, fileList } = e;
        if (file.status === 'done') {
            if (file.response?.retCode === 0) {
                const imgId = file.response.retData;
                const validFile = {
                    uid: imgId,
                    name: file.name,
                    url: getBaseImgLookUrl(imgId),
                };
                return fileList.map(item => item.uid === file.uid ? validFile : item);
            } else {
                message.error('文件上传失败，请重新上传!');
                return fileList.filter(item => item.uid !== file.uid);
            }
        }
        if (file.status === 'error') {
            message.error('文件上传失败，请重新上传!');
            return fileList.filter(item => item.uid !== file.uid);
        }
        return fileList;
    };
    const onPreview = (file: UploadFile<any>) => {
        Modal.info({
            title: '图片查看(点击图片放大)',
            content: <Image style={{ width: '100%' }} src={getBaseImgLookUrl(file.uid)} />,
            okText: '确定',
            cancelText: '取消',
            centered: true,
            width: 800,
        });
    };

    //表单提交
    const onSubmit = async () => {
        let data: any = {}
        let materialDetal: any[] = []
        // debugger;

        try {
            await form.validateFields().then(warehouseList => {
                materialDetal = warehouseList.materialDetal
            })
            // if(!(materialDetal && materialDetal.length > 0)){
            //     globalPrompt("message", { text: "请添", type: "error"})
            //     return
            // }
            await formRef.current?.validateFields().then((res) => {
                data = {
                    ...res,
                    fileMsg: res.fileList ? JSON.stringify(res.fileList) : ''
                }
            })
            let newMaterialDetal = materialDetal.map(item => ({
                materialCode: data.code,
                materialName: data.name,
                // shopCode, shopId, shopName,
                ...item,
            }))



            if (detailsInfo.mode === "edit") {
                editGoods({
                    ...editFormVal,
                    ...data,
                    id: detailsInfo.id,
                    materialDetal: newMaterialDetal
                } as IFormGoodsFields).then(res => {
                    res && onClose();
                    updateEditFormVal(null);
                })
            } else {
                insertGoods({
                    ...data,
                    materialDetal: newMaterialDetal
                } as IFormGoodsFields).then(res => {
                    setSelectedRowKeys([res as string])
                    res && onClose();
                    updateAddFormVal(null);
                })
            }
        } catch (err) {
            message.warning(getFormValidatorErrText(err as any));
        }

    }
    const onTreeSelectChange = (value: string, node: ITreeSelectData) => {
        if (node.pcode == 'material-type') {
            node && onChange({ typeCode: node.value, typeName: node.title, typeCategory: 'category.big' });
        } else {
            node && onChange({ typeCode: node.value, typeName: node.title, typeCategory: 'category.small' });
        }
    }

    //实时保留缓存
    const onChange = (changedValues: { [key: string]: any }) => {
        detailsInfo.mode === "edit" ? updateEditFormVal(changedValues) : updateAddFormVal(changedValues);
    }
    const onSelectChanges = async (value: string, option: ISelectOption) => {
        let params = {
            pageSize: 100000,
            pageNum: 1,
            warehouseCode: value,
        }
        const { retData } = await warehouseService.shelfAllPage(params)
        const newRecords = retData.map((item: IVRMshelfDetail) => { return { ...item, name: item.code } })
        setShelfAllList(newRecords)
    }

    const baseFormItem: IYhFormItemsBox = {
        title: "基础信息",
        style: { marginBottom: "10px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "配件编号",
                fieldName: "code",
                disable: mode != "add",
                rules: [{ required: true, message: "请输入配件编号" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "配件名称",
                fieldName: "name",
                rules: [{ required: true, message: "请输入配件名称" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "配件品牌",
                fieldName: "brandCode",
                allowClear: true,
                showSearch: true,
                options: getSelectedDictOne(DictCodeEnmu.MATERIAL_BRAND),
                rules: [{ required: true, message: "请选择品牌" }]
            }, {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: "商品类型",
                fieldName: "typeCode",
                showSearch: true,
                //options: getSelectedDictOne(DictCodeEnmu.MATERIAL_TYPE),
                treeData: getTreeSelectOne(DictCodeEnmu.MATERIAL_TYPE),
                onTreeSelectChange,
                rules: [{ required: true, message: "请选择商品类型" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "库存上限",
                fieldName: "limitUpper",
                rules: [{ required: true, message: "请选择库存上限" }]

            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "库存下限",
                fieldName: "limitLower",
                rules: [{ required: true, message: "请选择库存下限" }]

            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "所属站点",
                disable: true,
                fieldName: "shopName",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "适用车型",
                fieldName: "vehicleModel"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "规格型号",
                fieldName: "model"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "产地",
                fieldName: "madeFrom",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "单位",
                fieldName: "unitCode",
                allowClear: true,
                showSearch: true,
                options: getSelectedDictOne(DictCodeEnmu.MATERIAL_UNIT),
                // }, {
                //     type: FormItemTypeEnum.Select,
                //     fieldLabel: "所属仓库",
                //     fieldName: "warehouseCode",
                //     allowClear: true,
                //     showSearch: true,
                //     onSelectChange: onSelectChanges,
                //     options: transOptions(warehouseList),

                // }, {
                //     type: FormItemTypeEnum.Select,
                //     fieldLabel: "所属货位",
                //     fieldName: "shelfCode",
                //     allowClear: true,
                //     showSearch: true,
                //     options: transOptions(shelfAllList),

            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "最小起订量",
                fieldName: "minOrderNum"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "替换编号",
                fieldName: "replaceCode",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "上装品牌",
                fieldName: "upperClothBrand"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "底盘品牌",
                fieldName: "chassisBrand",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "商品类别",
                fieldName: "typeCategory",
                allowClear: true,
                disable: true,
                showSearch: true,
                options: getSelectedDictOne(DictCodeEnmu.MATERIAL_TYPECATEGORY),
            }, {
                type: FormItemTypeEnum.Switch,
                fieldLabel: "商品状态",
                fieldName: "enable"
            },

        ]
    };

    // const priceFormItem: IYhFormItemsBox = {
    //     title: "商品价格",
    //     style: {   marginBottom: "15px" },
    //     items: [
    //         {
    //             type: FormItemTypeEnum.Input,
    //             fieldLabel: "进货价",
    //             fieldName: "purchasePrice",
    //             rules: [{ required: true, message: "请输入进货价" }, { pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/, message: '请输入数值类型,可保留二位位小数' }]

    //         }, {
    //             type: FormItemTypeEnum.Input,
    //             fieldLabel: "零售价",
    //             fieldName: "retailPrice",
    //             rules: [{ required: true, message: "请输入零售价" }, { pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/, message: '请输入数值类型,可保留二位位小数' }]

    //         },
    //     ]
    // }

    const otherFormItem: IYhFormItemsBox = {
        title: "其它信息",
        // disabled: true,
        style: { marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                fieldName: "createUser",
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改人",
                fieldName: "updateUser",
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改时间",
                fieldName: "updateTime",
                disable: true,
            }
        ]
    }

    const priceFormItem: IYhFormItemsBox = {
        title: <><span>配件图片</span><span style={{ color: '#3e67f4', fontSize: '13px', marginLeft: '10px' }}>(开启后按住 ctrl 可选择多个文件)</span></>,
        // disabled: true,
        items: [
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '配件图片',
                fieldName: 'fileList',
                colClassName: 'ant-col-h-auto',
                span: 24,
                formItem: (
                    <Form.Item
                        name="fileList"
                        valuePropName="fileList"
                        getValueFromEvent={normFile}
                    >
                        <Upload
                            onPreview={onPreview}
                            name="file"
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            listType="picture-card"
                            multiple
                            maxCount={3}
                            accept="image/*"
                            disabled={mode === DetailType.look}
                        >
                            {/* 修复后的上传按钮显示条件 */}
                            {
                                (Array.isArray(typeForm[mode].fileList) ? typeForm[mode].fileList.length : 0) < 3
                                && mode !== "look"
                                && (
                                    <div style={{ marginTop: '15px' }}>
                                        <UploadOutlined />
                                        <div>上传照片</div>
                                        <div style={{ color: '#4abca5', fontSize: '13px' }}>(最多上传3张)</div>
                                    </div>
                                )
                            }
                        </Upload>
                    </Form.Item>
                ),
            }
        ]
    }
    const typeTitle = {
        add: "新增",
        edit: "编辑",
        look: "查看",
    }
    const supplierFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 6 },
        disabled: mode === DetailType.look,
        labelAlign: "right",
        // formValues: detailsInfo.mode === "edit" ? editFormVal : addFormVal,
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem, priceFormItem]
    }

    const reset = async () => {
        formRef.current?.resetFields()
        form.resetFields()
        if (detailsInfo.mode === "add") {
            setAddFormVal(initForm)
            setWarehouseDetalList([initWarehouseDetalList])
        } else if (detailsInfo.mode === "edit") {
            getGoodsOne(detailsInfo.id, mode)
        }
        message.success("重置成功")
    }
    const action = <>
        {mode != "look" &&
            <YhAuth resCode={ResourceAuthEnum.DATA_M_ED_SAVE}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    loading={saveLoading}
                    onClick={debounce(() => { onSubmit() }, 900)}
                >{saveLoading ? '保存中' : '保存'}</Button>
            </YhAuth>
        }
        {mode != "look" && <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => { reset() }}
        >重置</Button>}
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={onClose}
        >取消</Button>
    </>;
    const setFormShelfs = (index: number, fieldName: string, fieldVal: ISelectOption) => {
        console.log(fieldVal)
        let fromVal: IMaterialDetail = form.getFieldsValue();
        let newVal = fromVal?.materialDetal?.[index];
        //判断更改仓库时仓库重新选择
        if (fieldName === "warehouseCode") {
            fromVal?.materialDetal?.splice(index, 1, { ...newVal, "warehouseName": fieldVal.label, warehouseId: getFindItem(fieldVal.value as string, warehouseList)?.id, "shelfCode": undefined });
            onSelectChanges(fieldVal.value as string, fieldVal)
        } else if (fieldName === "shelfCode") {
            fromVal?.materialDetal?.splice(index, 1, { ...newVal, "shelfId": getFindItem(fieldVal.value as string, shelfAllList)?.id as string });
        } else {
            fromVal?.materialDetal?.splice(index, 1, { ...newVal, [fieldName]: fieldVal.label });
        }
    }
    const typeWarehouseForm = {
        add: warehouseDetalList,
        edit: editWarehouseDetalList,
        look: lookWarehouseDetalList
    }
    useEffect(() => {
        form.setFieldsValue({ materialDetal: typeWarehouseForm[mode] });
    }, [typeWarehouseForm[mode]])
    const defaultColumns: any = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '供应商名称',
            width: 120,
            dataIndex: 'supplierName',
        }, {
            title: '询价单号',
            width: 150,
            dataIndex: 'enquiryCode',
        }, {
            title: '含税单价',
            width: 150,
            dataIndex: 'offerPrice',
        }, {
            title: '截止时间',
            width: 150,
            dataIndex: 'endTime',
        },
    ];
    return (
        <>
            {/* <YhPageHeader title="配件档案详情" /> */}
            {/* <YhBox title={`配件档案${typeTitle[mode]}`} action={action} style={{ paddingBottom: "0px", marginBottom: "15px" }}></YhBox> */}
            <YHDetailNav
                title={`配件档案${typeTitle[mode]}`}
                btns={action}
                style={{ marginBottom: '6px' }}
            />
            <YhFormBox {...supplierFromConfig} />
            <Form form={form}
                // labelCol:{{span:3}}
                // labelCol={{ span: 6 }}
                autoComplete="off"
            // initialValues={{
            //     materialDetal: typeWarehouseForm[mode]
            // }}
            >
                <YhBox title="价格信息"
                >

                    <Form.List name="materialDetal">
                        {(fields, { add, remove }) => {
                            return (
                                <>
                                    {fields.map((field, index) => (
                                        <Space key={field.key}
                                            align="baseline"
                                            style={{ paddingLeft: "35px" }}
                                        >

                                            <Form.Item
                                                {...field}
                                                name={[field.name, 'purchasePrice']}
                                                label="进货价"
                                                style={{ width: "350px" }}
                                                rules={[{ required: true, message: '请输入进货价' }]}

                                            >
                                                <Input
                                                    placeholder="进货价"
                                                    disabled={mode === DetailType.look}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                {...field}
                                                name={[field.name, 'repairPrice']}
                                                label="零售价"
                                                style={{ width: "350px" }}
                                                rules={[{ required: true, message: '请输入零售价' }]}

                                            >
                                                <Input
                                                    placeholder="零售价"
                                                    disabled={mode === DetailType.look}
                                                />
                                            </Form.Item>

                                        </Space>

                                    ))}

                                </>

                            )
                        }}
                    </Form.List>
                </YhBox>
            </Form>
            <Form form={form}
                // labelCol:{{span:3}}
                // labelCol={{ span: 6 }}
                autoComplete="off"
            // initialValues={{
            //     materialDetal: typeWarehouseForm[mode]
            // }}
            >
                <YhBox title="其它信息"
                    style={{ marginTop: '10px' }}
                >
                    <Space
                        align="baseline"
                        style={{ paddingLeft: "35px" }}
                    >
                        <Form.Item
                            name={[typeForm[mode].createUser, 'createUser']}
                            label="创建人"
                            style={{ width: "350px" }}
                        >
                            <Input
                                defaultValue={typeForm[mode].createUser}
                                placeholder="自动生成"
                                disabled
                            />
                        </Form.Item>
                        <Form.Item
                            name={[typeForm[mode].createTime, 'createTime']}
                            label="创建时间"
                            style={{ width: "350px" }}
                        >
                            <Input
                                defaultValue={typeForm[mode].createTime}
                                placeholder="自动生成"
                                disabled
                            />
                        </Form.Item>
                        <Form.Item
                            name={[typeForm[mode].updateUser, 'updateUser']}
                            label="修改人"
                            style={{ width: "350px" }}
                        >
                            <Input
                                defaultValue={typeForm[mode].updateUser}
                                placeholder="自动生成"
                                disabled
                            />
                        </Form.Item>
                        <Form.Item
                            name={[typeForm[mode].updateTime, 'updateTime']}
                            label="修改时间"
                            style={{ width: "350px" }}
                        >
                            <Input
                                defaultValue={typeForm[mode].updateTime}
                                placeholder="自动生成"
                                disabled
                            />

                        </Form.Item>
                    </Space>
                </YhBox>
                {mode !== 'add' && <YhBox title="询价信息" style={{ marginTop: "10px", height: '300px' }}>
                    <Table
                        bordered
                        rowKey={(record: any) => record.id as string}
                        columns={defaultColumns}
                        dataSource={dataList}
                        pagination={false}
                        scroll={{ x: 'max-content', y: 200 }}
                    />
                </YhBox>}
            </Form>
        </>
    )
}
